import React from 'react';

import { Title } from '../typography';
import LearnMore from 'components/learnMore';

import {
  learnMore,
  moreUpdatesSection,
} from './scss/MoreUpdatesSection.module.scss';

const MoreUpdatesSection = () => {
  return (
    <section className={moreUpdatesSection}>
      <Title
        value={
          <span>
            {`We’re transforming agriculture through`}
            <br className="d-none d-lg-block" />
            {` intelligence and insight.`}
          </span>
        }
        size="xl"
      />
      <div>
        <LearnMore
          className={learnMore}
          prefix="SEE MORE"
          context="UPDATES"
          theme="regular"
          arrowType="primary"
          href="/updates"
        />
      </div>
    </section>
  );
};

export default MoreUpdatesSection;
